import React from "react";

const Inputtext = () => {
  return (
    <div className="mt-10 ml-10  mb-10 ">
      <input
        id="companyName"
        value="Spotmies LLP"
        className="w-50 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
        readOnly
      />
    </div>
  );
};

export default Inputtext;
